import Link from 'next/link'

export const RequestVendorCheatsheetButton: React.FC = () => {
  return (
    <div className="w-full text-center">
      <Link
        href={`mailto:${process.env.NEXT_PUBLIC_CONTACT_US_URL}?subject=Access request for the Vendor Cheatsheet`}
        className="text-white font-secondary text-[14px] font-bold text-center px-[25px] m-auto mt-auto mb-[60px] bg-navybright rounded-[50px] w-[700px] py-[10px]"
      >
        This newsletter is only available to LTH vendors. If you would like access to a specific piece of content from
        the Vendor Cheatsheet, click here
      </Link>
    </div>
  )
}
